module.exports = "/lucky-balls/img/jackpot/012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/012.png
// module id = 1112
// module chunks = 0